import React from 'react';
import './DocumentItem.scss';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileExcel,
  faFilePdf,
  faFileArchive,
  faFileWord,
  faFileImage,
  faFile,
} from '@fortawesome/free-solid-svg-icons';

const DocumentsItem = ({ data }) => {

  const getIconByExtension = (extension) => {
    switch (extension) {
      case 'pdf':
        return (<FontAwesomeIcon style={{ fontSize: 23 }} color="#313C52" icon={faFilePdf} />);
      case 'docs':
        return (<FontAwesomeIcon style={{ fontSize: 23 }} color="#313C52" icon={faFileWord} />);
      case 'xlsx':
        return (<FontAwesomeIcon style={{ fontSize: 23 }} color="#313C52" icon={faFileExcel} />);
      case 'rar':
        return (<FontAwesomeIcon style={{ fontSize: 23 }} color="#313C52" icon={faFileArchive} />);
      default:
        return (<FontAwesomeIcon style={{ fontSize: 23 }} color="#313C52" icon={faFileImage} />);
    }
  };

  return (
    <div className="documents-container">
      {
            data.length
              ? (
                <List classes={{ root: 'py-0' }}>
                  {
                        data.map(item => (
                          <div key={item.crmid}>
                            <ListItem divider className="document-item">
                              <ListItemIcon>
                                {
                                getIconByExtension(item.extension)
                            }
                              </ListItemIcon>
                              <ListItemText
                                primary={`${item.filename}.${item.extension}`}
                                classes={{
                                  primary: 'document-title',
                                  secondary: 'document-subtitle',
                                }}
                              />
                            </ListItem>
                          </div>
                        ))
                    }
                </List>
              )
              : (
                <div className="empty-email">
                  <FontAwesomeIcon
                    style={{
                      fontSize: 40, display: 'flex', justifyContent: 'center', alignItems: 'center',
                    }}
                    color="#64707A"
                    icon={faFile}
                  />
                  <span>Sin documentos </span>
                </div>
              )
        }
    </div>
  );
};

export default DocumentsItem;
